// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  reportId: __t.u64().primaryKey().name("report_id"),
  worldId: __t.u64().name("world_id"),
  reporter: __t.identity(),
  reason: __t.string(),
  verified: __t.bool(),
  at: __t.timestamp(),
});
